import { Injectable } from "@angular/core";
import { HttpService } from "../../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  URLSearchParams,
} from "@angular/http";
import { Router } from "@angular/router";
import { SessionStorage } from "ngx-webstorage";
import { ErrorsService } from "../../../utils/services/errors.service";
import { catchError } from 'rxjs/operators';

@Injectable()
export class AddProjectService {
  @SessionStorage() public user;

  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  /* Get project information  */
  getProjectInfo(id: string) {
    return this.httpService
      .get(`project/${id}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  triggerAPI(data: any): Observable<any> {
    return this.httpService.get(`projectapi/${data.projectID}`).pipe(
      catchError((error: any) => {
        return this.handleError(error);
      })
    );
  }
  // Add project
  addProject(data) {
    return this.httpService
      .post(`addproject`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Add project
  updateProject(data) {
    return this.httpService
      .put(`updateproject`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //Function to save project
  saveProject(data) {
    return this.httpService
      .post(`project`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //Function to upload CSV file
  uploadCSV(activity: any): Observable<any> {
    let headers = new Headers();
    headers.append("Accept", "application/json, text/csv,");
    headers.append("Empname", this.user.Empname);
    headers.append("EmailID", this.user.EmailID);
    let options = new RequestOptions({ headers: headers });
    return this.httpService
      .post(`project`, activity, options)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //Function to get uploaded history
  uploadHistory() {
    const data = { type: "project" };
    return this.httpService
      .post(`listfileUploadHist`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //Function to handle error data
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
  //Function to get uploaded history
  getAllProjects(bu) {
    return this.httpService
      .get(`getAllProjects`, bu)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  //Function to get Master Project
  getAllMasterProjects() {
    return this.httpService
      .get(`galaxyProjects`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /*Get the employee list from the Backend */
  getEmployeesDetails(searchText: string): Observable<any> {
    return this.httpService
      .post(`employee/search`, {
        searchText: searchText,
      })
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/project/add-project/add-project.service.ts